module.exports = __webpack_public_path__ + "img/icon_wy03.3183dc96.png";